var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84766 3C7.78624 3 5.96647 4.0397 4.88598 5.625H6.84766V7.125H2.34766V2.625H3.84766V4.49952C5.21551 2.67875 7.39339 1.5 9.84766 1.5C13.9898 1.5 17.3477 4.85786 17.3477 9H15.8477C15.8477 5.68629 13.1614 3 9.84766 3ZM3.84766 9C3.84766 12.3137 6.53395 15 9.84766 15C11.9091 15 13.7288 13.9603 14.8094 12.375H12.8477V10.875H17.3477V15.375H15.8477V13.5005C14.4798 15.3212 12.302 16.5 9.84766 16.5C5.70552 16.5 2.34766 13.1421 2.34766 9H3.84766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undoIcon.ffe684da.svg";
export { ForwardRef as ReactComponent };